// extracted by mini-css-extract-plugin
module.exports = {"tabList":"tab-group_tabList__XLYXu","tabListItem":"tab-group_tabListItem__zqkEV"};